import { render, staticRenderFns } from "./EditNum.vue?vue&type=template&id=10e5806a&scoped=true&"
import script from "./EditNum.vue?vue&type=script&lang=js&"
export * from "./EditNum.vue?vue&type=script&lang=js&"
import style0 from "./EditNum.vue?vue&type=style&index=0&id=10e5806a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5806a",
  null
  
)

export default component.exports